import {Helmet} from "react-helmet";
import React from "react";
import YoutubePlayer from "../../components/youtubeplayer/YoutubePlayer";
import ContactsComponent from "../../components/ContactsComponent";
import {motion} from "framer-motion";

const AdmissionPage = () => {

  const headingVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
  <div className="container">
    <Helmet>
      <meta name="description" content="Поступление в МАИ лично и онлайн через портал Госуслуг и личный кабинет абитуриента МАИ"/>
      <meta name="keywords" content={'поступление 2023, суперсервис, госуслуги, поступление онлайн, личный кабинет абитуриента'} />
    </Helmet>
    <motion.h1
        className="main-title"
        initial="hidden"
        animate="visible"
        variants={headingVariants}
        transition={{ duration: 0.3 }}
    >
      Приемная комиссия
    </motion.h1>
    <h2 className="title">Способы подачи документов</h2>
    <div className="content">
      <h3 className="section-title">Личная подача</h3>
      <div className='highlight-content'>
      <p className="section-text">
        Наиболее удобным и простым способом подачи документов в Институт №8 МАИ является личное посещение Приемной комиссии. Приходите к нам по адресу <a href={'https://yandex.ru/maps/-/CCUDB-tEpD'} style={{textDecoration: 'none', color: '#007ACD'}} target="_blank" rel="noopener noreferrer">г. Москва, Волоколамское шоссе, 4к6</a> с 10:00 до 17:00 по будням и с 10:00 до 14:00 в субботу. Обязательно при себе имейте документ, удостоверяющий вашу личность (Паспорт РФ), СНИЛС, а также документ об образовании (аттестат или диплом). Если у вас есть документы, подтверждающие индивидуальные достижения, особые права или льготы, возьмите их с собой. Наша команда сотрудников с удовольствием ответит на все возникающие вопросы и поможет оформить заявление на поступление. При необходимости вы сможете вносить изменения в поданное заявление через <a href={'https://lk.mai.ru'} style={{textDecoration: 'none', color: '#007ACD'}} target="_blank" rel="noopener noreferrer">личный кабинет абитуриента МАИ</a>.
      </p>
      </div>
      <h3 className="section-title">Личный кабинет абитуриента МАИ</h3>
      <div className='highlight-content'>
        <p className='section-text'>Для подачи заявления в Институт №8 МАИ через личный кабинет абитуриента, необходимо зарегистрироваться на <a href="https://lk.mai.ru" style={{textDecoration: 'none', color: '#007ACD'}} target="_blank" rel="noopener noreferrer">lk.mai.ru</a>.</p>
        <p className='section-text'>После регистрации выберите "Подать новое заявление". Укажите уровень образования, основу обучения и необходимость общежития.</p>
        <p className='section-text'>Заполните ФИО, дату и место рождения согласно паспортным данным, приложите скан СНИЛС. Укажите номер телефона и отметьте согласие на обработку персональных данных.</p>
        <p className='section-text'>Заполните адрес регистрации и фактического проживания, если они совпадают - поставьте соответствующую галочку. Заполните данные паспорта и приложите скан главного разворота, старницы с действующей регистрацией и 19 страницу (если паспорт менялся и ЕГЭ сдавался по старому паспорту). Добавьте информацию о документе об образовании и приложите скан всех страниц аттестата/диплома с приложением. Введите средний балл аттестата/диплома. Если есть особенности поступления или индивидуальные достижения, укажите и приложите соответствующие сканы.</p>
        <p className='section-text'>Укажите все предметы и результаты экзаменов, которые вы сдавали. Если требуется сдача вступительных испытаний, выберите тип экзамена "ВИ".</p>
        <p className='section-text'>Выберите направления подготовки в Институте №8: 01.03.00 (Компьютерные науки и прикладная математика) и 02.03.02 (Фундаментальная информатика и информационные технологии). Укажите профили обучения в порядке приоритетности.</p>
        <p className='section-text'>Проверьте все введенные данные и отправьте заявление. Оно будет обработано в течение 1-3 рабочих дней.</p>
        <div>
          <YoutubePlayer videoId={"O1g7B6nKBI8"} />
        </div>
      </div>
      <motion.div
          style={{ maxWidth: '700px', border: 'none', margin: '0 auto'}}
          className="highlight"
          onClick={() => window.open('https://lk.mai.ru', '_blank')}
      >
        <motion.div className="button_sec" style={{backgroundColor: '#007acd', color: 'white', fontSize: '1.2rem', fontWeight: 'normal'}}>
          Подать заявление на поступление через личный кабинет МАИ
        </motion.div>
      </motion.div>
      <h3 className="section-title">Суперсервис от Госуслуг</h3>
      <div className='highlight-content'>
      <p className="section-text">
        Для подачи заявления на поступление в Институт №8 через Госуслуги нужно иметь подтвержденную учетную запись. Перейдите на <a href={'https://www.gosuslugi.ru/vuzonline'} style={{textDecoration: 'none', color: '#007ACD'}} target="_blank" rel="noopener noreferrer">страницу сервиса</a> и нажмите кнопку "Подать заявление". Выберите программу бакалавриата, если это ваш выбор. Укажите предыдущее учебное заведение. Если у вас есть особое или преимущественное право, выберите соответствующую категорию и приложите документы. Если вы поступаете по целевому договору, предоставьте информацию о договоре. Ознакомьтесь с перечнем необходимых документов и создайте заявление о поступлении. Если вам нужно место в общежитии, отметьте эту опцию. Выберите МАИ из списка учебных заведений.
      </p>
      <div className="m_container">
        <div className="m_highlighted-text">Если вы хотите подать заявление на 01.03.00 "Компьютерные науки и прикладная математика", то на портале необходимо выбирать направление 01.00.00 "Математика и механика."</div>
      </div>
      <p className="section-text">
        Обратите внимание на количество доступных бюджетных мест. Они указаны за вычетом мест на целевую, особую и отдельную квоты (по 10% на каждую). Укажите свои индивидуальные достижения и приоритеты для каждого направления. Добавьте данные аттестата и загрузите собственное фото. Проверьте свои персональные данные и отправьте заявление.
      </p>
        <p className="section-text">
          Более подробно ознакомиться с процессом подачи заявления через суперсервис от Госуслуг можно в нашей видео-инструкции:
        </p>
        <div>
          <YoutubePlayer videoId={"8fdqiUmj-8E"} />
        </div>
      </div>

      <motion.div
          style={{ maxWidth: '700px', border: 'none', margin: '0 auto'}}
          className="highlight"
          onClick={() => window.open('https://www.gosuslugi.ru/vuzonline', '_blank')}
      >
        <motion.div className="button_sec" style={{backgroundColor: '#007acd', color: 'white', fontSize: '1.2rem', fontWeight: 'normal'}}>
          Подать заявление на поступление через Госуслуги
        </motion.div>
      </motion.div>
    </div>

    <section id="contacts">
      <h2 className="section-title">Контакты</h2>
      <ContactsComponent />
    </section>
  </div>
  )}

export default AdmissionPage;